export default __webpack_public_path__ + "static/media/icn-room_size.87b8cabe.svg";